import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    item: {
        "&.MuiButtonBase-root": {
            fontSize: theme.typography.subtitle2.fontSize,
            fontFamily: theme.typography.subtitle2.fontFamily,
            color: theme.palette.text.primary,
            boxShadow: "inset 0px -1px 0px rgba(0, 0, 0, 0.12)",
        },
    },
    threeDotsMenuButton: {
        "&.MuiButtonBase-root": {
            padding: 0,
            minWidth: "auto",
            width: theme.spacing(10),
            height: theme.spacing(10),
            background: theme.palette.border.select,
            color: theme.palette.menu.icons.main,
            border: "none",
            "&:hover": {
                background: theme.palette.border.select,
                border: "none",
            },
        },
        "&.MuiButtonBase-root .MuiSvgIcon-root": {
            fontSize: "24px",
        },
    },
}));

export const paperPropsStyles = {
    maxHeight: 48 * 4.5,
    minWidth: "20ch",
    padding: "10px",
};
